import { CURRENCY_PRICE_RANGES, getCurrencySymbol } from '@/common/constant';
import type { Currency } from '@/common/db-typebox';
import { useAuth } from '../stores/AuthContext';

export const useCurrencySymbol = () => {
  const { user } = useAuth();
  const currency = (user?.profile?.currency as Currency) || 'USD';
  const symbol = getCurrencySymbol(currency);
  const priceRange = CURRENCY_PRICE_RANGES[currency];

  return { currency, symbol, priceRange };
};
